import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchNycbsPharmaCompletedOrdersFromApi } from "../../redux/slice/nycbsPharmaExternal/nycbsPharmaCompletedOrder";
import { AppDispatch } from "../../redux/store/store";
import NycbsCompletedTable from "./nycbsCompletedTable/nycbsCompletedTable";

const NycbsCompletedLayout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const initialLimit = 40;

  useEffect(() => {
    dispatch(fetchNycbsPharmaCompletedOrdersFromApi(initialLimit));
  }, []);

  return (
    <div className="nycbs_order__layout h-full w-full rounded-lg bg-primaryGray-16 px-4 pb-4">
      <div className="nycbs_order__inner-container flex h-full flex-col gap-2 rounded bg-white p-4">
        <div className="nycbs_order__heading text-h11 font-bold">
          Completed PA Orders
        </div>
        <div className="nycbs_order__table-container flex-1 overflow-auto">
          <NycbsCompletedTable />
        </div>
      </div>
    </div>
  );
};

export default NycbsCompletedLayout;
